module.exports = __webpack_public_path__ + "img/a_dmitrova.f5c87763.jpg";